<template>
	<div class="main-content">
		<div class="center-body">
			<Nav />
			<div class="row">
				<img src="../../assets/img/khalBanner.png" style="width: 100%;" />
			</div>
			<div class="mfty-box" style="background-color: #f0f0f0;height: 600px;">
				<div class="row ju-c al-c" style="color: #000;font-size: 32px;font-weight: bold;">
					客户案例
				</div>
				<div class="row ju-c al-c" style="margin-top: 20px;">
					<div class="item-no" style="width: 120px;height: 2px;background-color: #0fbee7;"></div>
				</div>
				<div style="width: 1100px;margin: 0 auto;">
					<div class="row" style="margin-top: 40px;">
						<div class="col">
							<div class="item-no" style="color: #000;font-size: 18px;">
								Maob-MES
							</div>
							<div class="item-no" style="color: #000;font-size: 22px;margin-top: 15px;">
								民生能源集团Maob-MES燃气设备成功导入
							</div>
							<div class="item-no"
								style="color: #666;font-size: 16px;margin-top: 25px;line-height: 24px;text-align: left;">
								民生能源集团始建于1996年，是集工民用天然气、成品油、旅游为一体的跨区域大型民营企业集团。旗下有分子公司50余个，拥有全国规模庞大功能齐全的民营工民用燃气输配网络。
							</div>
							<div class="item-no"
								style="color: #666;font-size: 16px;margin-top: 25px;line-height: 24px;text-align: left;">
								集团始终秉承“富民强司”的发展理念和“服务社会，造福于民”的企业宗旨，始终致力于社会公益和慈善事业，近年来累计捐资一亿七千余万多元。先后获得重庆市“诚信民营企业”、“民营企业五十强”、“工人先锋号”及“全国民族团结进步模范集体“、“全国就业与社会保障先进民营企业”、“中华慈善突出贡献奖”、“全国民营企业文化建设先进单位”、“全国关爱员工的民营企业”、“模范职工之家”、“青年文明号”等荣誉称号。
							</div>
						</div>
						<div class="col-no" style="margin-left: 30px;justify-content: flex-end;">
							<img src="../../assets/img/khalImg4.png" />
						</div>
					</div>
				</div>
			</div>


			<div class="mfty-box" style="background-color: #fff;height: 980px;">

				<div style="width: 1100px;margin: 0 auto;margin-top: 100px;">
					<div class="row" style="margin-top: 40px;padding-bottom: 80px;border-bottom: 1px #ccc solid;">
						<div class="col-no" style="justify-content: flex-start;width: 400px;">
							<div class="row">
								<div class="item-no" style="height: 24px;width: 3px;background-color: #0070FD;"></div>
								<div class="item"
									style="margin-left: 8px;color: #0070FD;font-size: 24px;font-weight: bold;">
									项目实施
								</div>
							</div>
						</div>
						<div class="col">
							<div class="item-no"
								style="color: #666;font-size: 16px;line-height: 24px;text-align: left;">
								贸宝信息结合民生的生产情况和各基地设备规模，为其规划了一套科学规范的设备管理解决方案，解决了民生能源在设备管理上的难题，极大的提高了管理工作的效率。
							</div>
							<div class="item-no"
								style="color: #666;font-size: 16px;line-height: 24px;margin-top: 30px;text-align: left;">
								为其量身定制了集设备管理、备件耗材管理、流程审批于一体的先进生产线设备统筹管理平台。使设备点检确认时间减少90%，整体管理效率提升20%，极大地消减了生产管理成本。
							</div>
						</div>
					</div>
					<div class="row" style="margin-top: 40px;padding-bottom: 80px;">
						<div class="col-no" style="justify-content: flex-start;width: 400px;">
							<div class="row">
								<div class="item-no" style="height: 24px;width: 3px;background-color: #0070FD;"></div>
								<div class="item"
									style="margin-left: 8px;color: #0070FD;font-size: 24px;font-weight: bold;">
									收益分析
								</div>
							</div>
						</div>
						<div class="col">
							<div class="item-no"
								style="color: #666;font-size: 16px;line-height: 24px;text-align: left;">
								通过民生能源集团设备管理的实施，规范配件仓储管理，配件条码化管理，移动终端扫码出入库、盘点，实现备件存取快速，降低备件损耗率。
							</div>
							<div class="item-no"
								style="color: #666;font-size: 16px;line-height: 24px;margin-top: 30px;text-align: left;">
								零部件安全库存预警，低于安全库存时，系统推送消息至负责人，并和在手机端查看详情。设备保养周期及内容自动提醒，提高维护精度。
							</div>
							<div class="item-no"
								style="color: #666;font-size: 16px;line-height: 24px;margin-top: 30px;text-align: left;">
								贸宝信息为民生能源集团打造先进的设备管理系统，使其真正做到设备责任到人，管理有序的效果，完善了设备管理，提升了效率。同时，贸宝信息也通过为合作伙伴制定专业的管理服务，不断提升自身实力。
							</div>
						</div>
					</div>
				</div>
			</div>

			<Foot />
		</div>
	</div>
</template>

<script>
	import Nav from "./nav.vue";
	import Foot from "./foot.vue";

	export default {
		name: "App",
		components: {
			Nav,
			Foot
		},
		data() {
			return {
				curHeight: 0,
				mouseIndex: -1
			};
		},
		watch: {
			windowHeight(val) {
				let that = this;
				console.log("实时屏幕高度：", val, that.windowHeight);
			},
		},
		beforeMount() {

			var h = document.documentElement.clientHeight || document.body.clientHeight;

			this.curHeight = h; //减去页面上固定高度height
		},
		methods: {
			enter(index) {
				this.mouseIndex = index
			},
			leave() {
				this.mouseIndex = -1
			}
		},
		mounted() {
			var that = this;
			window.onresize = () => {
				return (() => {
					window.fullHeight = document.documentElement.clientHeight;
					that.curHeight = window.fullHeight; // 高

				})()
			};
		},
	};
</script>
<style scoped>
	.main-content {
		min-height: 100%;
		width: 100%;
		margin: 0 auto;
		display: block;
		position: absolute;
		background: #f0f0f0;
		/* background: #f7f7f7; */
	}

	.center-body {
		margin: 0 auto;
	}

	.prduct-box {
		padding-top: 60px;
		width: 1200px;
		margin: 0 auto;
		position: relative;
	}

	.khal-tbox {
		height: 30px;
		background-color: #edf6ff;
		padding: 5px 15px;
		border-radius: 15px;
		color: #999;
	}

	.mfty-box {
		height: 600px;
		background-color: #fff;
		padding-top: 60px;
		text-align: center;
	}
</style>
